<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2024-02-23 13:54:22
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-07-29 16:24:35
 * @FilePath: /wemeet-admin-new/Users/hvv/weMeetSpace/wemeet-poster/src/views/mini-h5/pages/user_home_page/components/MainPageIntroduction.vue
 * @Description: 
 * Copyright (c) 2024 by WeMeet, All Rights Reserved. 
-->
<template>
  <div :class="customClass" class="bg-white d-flex flex-column pb-12  mt-10 br-12 pl-12 pr-6 pt-15 border-box text-left">
    <div class="cor-262626 fz-17 fw-7 mr-6">{{$t('lang.t153')}}</div>
    <!-- 文字内容 -->
    <div class="cor-262626 fz-16 mt-14 text-wrap mr-6">{{userProfile.content}}</div>
    <!-- 视频图片 -->
    <div class="d-flex flex-wrap mt-9" v-if="userProfile.attachmentVos && userProfile.attachmentVos.length > 0">
      <div class="col-6 pr-6 pb-6 border-box" v-for="(item, index) in userProfile.attachmentVos" :key="index">
        <img @click="previewUrl(item.fileUrl, index)" class=" w-full d-block br-10" v-if="item.fileType == 1" :src="item.fileUrl" alt="" style="height: 157px;object-fit:cover;">
        <video x5-video-player-type="h5" class=" w-full d-block br-10" initial-time='0.01' :src="item.fileUrl" controls v-if="item.fileType == 3" style="height: 157px;object-fit: cover;"></video>
      </div>
    </div>
  </div>
</template>
<script>
import { ImagePreview } from 'vant'
export default {
  name: 'MainPageIntroduction',
  props: {
    customClass: {
      type: String,
      default: 'mx-12',
    },
    title: {
      type: String,
      default: 'Personal Introduction',
    },
    userProfile: {
      type: Object,
      default: {
        attachmentVos: [],
        content: '',
      },
    },
  },
  components: {},
  data() {
    return {}
  },
  methods: {
    previewUrl(fileUrl,index) {
      console.log(this.userProfile)
      let url = this.userProfile.attachmentVos.map((v) => { return v.fileType == 1 ? v.fileUrl : ''}).filter( v => v != '')
      console.log(url)
      ImagePreview({
        images: url,
        startPosition: index,
        closeable: true,
      })
    },
  },
  mounted() {},
}
</script>
